export const GET_DASH_ICONS = "GET_DASH_ICONS"
export const GET_DASH_ICONS_SUCCESS = "GET_DASH_ICONS_SUCCESS"
export const GET_DASH_ICONS_FAIL = "GET_DASH_ICONS_FAIL"

export const GET_BOTTOM_NAV = "GET_BOTTOM_NAV"
export const GET_BOTTOM_NAV_SUCCESS = "GET_BOTTOM_NAV_SUCCESS"
export const GET_BOTTOM_NAV_FAILED = "GET_BOTTOM_NAV_FAILED"

export const GET_ACAD_ID_START = "GET_ACAD_ID_START"
export const GET_ACAD_ID_SUCCESS = "GET_ACAD_ID_SUCCESS"
export const GET_ACAD_ID_FAIL = "GET_ACAD_ID_FAILL"


// export const STORE_DIV = "STORE_DIV"
// export const STORE_RESET = "STORE_DIV"